import React from "react";
import { connect } from "react-redux";
import { FaPlus } from "react-icons/fa";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";
import MiniLoader from "./MiniLoader";
import ReelCard from "./ReelCard";
import ModalStoreAddReel from "./ModalStoreAddReel";
import "./styles/Alertify.css";
import "./styles/AlertifyTheme.css";
import "./styles/Alertify.min.css";
import "./styles/AlertifyTheme.min.css";
import "./styles/ReelsCarousel.css";
import "./styles/StoreReels.css";
import * as actions from "../redux/actions/reelActions";
import * as actions_media from "../redux/actions/mediaActions";
import * as actions_store_ad from "../redux/actions/marketstoreAdListActions";

class StoreReels extends React.Component {
  state = {
    modalOpen: false,
  };

  componentDidMount() {
    this.loadReels();
    if (this.isOwner()) {
      this.loadStoreAds();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.marketstore?.Id !== this.props.marketstore?.Id) {
      this.loadReels();
      if (this.isOwner()) {
        this.loadStoreAds();
      }
    }
  }

  isOwner() {
    const { marketstore, user_id } = this.props;
    if (!marketstore?.UserId || !user_id) return false;
    return String(marketstore.UserId) === String(user_id);
  }

  loadReels = () => {
    const storeId = this.props.marketstore?.Id;
    if (!storeId) return;

    this.props.LoadList(this.props.user_id, this.props.token, storeId);
  };

  loadStoreAds = () => {
    const storeId = this.props.marketstore?.Id;
    if (!storeId || !this.props.token || !this.props.user_id) return;

    this.props.LoadAdStore(storeId, this.props.user_id, this.props.token, true);
  };

  openModal = () => {
    if (!this.isOwner()) return;
    this.loadStoreAds();
    this.setState({ modalOpen: true });
  };

  closeModal = () => {
    this.setState({ modalOpen: false });
  };

  onReelAdded = () => {
    this.loadReels();
  };

  onDeleteReel = (item) => {
    if (!this.isOwner()) return;

    alertify
      .confirm(
        I18n.t("warning"),
        I18n.t("store_reels_delete_confirm"),
        async () => {
          try {
            const result = await this.props.DeleteMedia(this.props.token, {
              media_id: item.Id,
              id: this.props.user_id,
            });

            if (!result?.success) {
              alertify.warning(I18n.t(result?.error || "try_later"));
              return;
            }

            this.props.RemoveReelFromList(item.Id);
            alertify.success(I18n.t("deleted"));
          } catch (error) {
            console.log(error);
            alertify.warning(I18n.t("try_later"));
          }
        },
        () => {}
      )
      .set("labels", {
        ok: I18n.t("store_reels_delete"),
        cancel: I18n.t("profile_configuration_delete_cancel"),
      });
  };

  renderOwnerToolbar() {
    if (!this.isOwner()) return null;

    return (
      <div className="store-reels-toolbar">
        <div className="store-reels-toolbar__text">
          <h3 className="store-reels-toolbar__title">
            <Translate value="reels_title" />
          </h3>
          <p className="store-reels-toolbar__subtitle">
            <Translate value="store_reels_subtitle" />
          </p>
        </div>
        <button type="button" className="store-reels-add-btn" onClick={this.openModal}>
          <FaPlus />
          <Translate value="store_reels_add" />
        </button>
      </div>
    );
  }

  render() {
    const { list, loading } = this.props;
    const isOwner = this.isOwner();

    if (loading) {
      return (
        <React.Fragment>
          {this.renderOwnerToolbar()}
          <div className="store-reels-loading">
            <MiniLoader />
          </div>
        </React.Fragment>
      );
    }

    if (!list.length) {
      return (
        <React.Fragment>
          {this.renderOwnerToolbar()}
          <div className="store-reels-empty-wrap">
            <p className="reels-section__empty store-reels-empty">
              <Translate
                value={isOwner ? "store_reels_empty_owner" : "reels_empty"}
              />
            </p>
          </div>
          <ModalStoreAddReel
            isOpen={this.state.modalOpen}
            onClose={this.closeModal}
            onSuccess={this.onReelAdded}
          />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        {this.renderOwnerToolbar()}
        <div className="store-reels-grid">
          {list.map((item) => (
            <ReelCard
              key={item.Id}
              item={item}
              storeId={this.props.marketstore?.Id}
              canDelete={isOwner}
              onDelete={() => this.onDeleteReel(item)}
            />
          ))}
        </div>
        <ModalStoreAddReel
          isOpen={this.state.modalOpen}
          onClose={this.closeModal}
          onSuccess={this.onReelAdded}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    marketstore: reducer.marketstore.item,
    list: reducer.reel.list,
    loading: reducer.reel.loading,
    error: reducer.reel.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadList: (user_id, token, store_id) =>
    dispatch(actions.loadList({ user_id, token, store_id })),
  LoadAdStore: (id, user_id, token, owner_scope = false) =>
    dispatch(actions_store_ad.loadList({ id, user_id, token, owner_scope })),
  DeleteMedia: (token, params) =>
    dispatch(actions_media.deleteItem({ token, params })),
  RemoveReelFromList: (id) => dispatch(actions.removeFromList(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoreReels);
